import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';

import * as sha1 from 'js-sha1';

import * as _ from 'lodash'


import { ReponseWebService } from '../datastruct/Meloyi.module';



const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};




@Injectable({
  providedIn: 'root'
})
export class ServicepoolService {
											   
	baseUrlRem1 = "https://paysys.hybraine.com/sunupay-sys/btnsrl/" ;

	baseUrlRemFirstSys = "https://paysys.hybraine.com/sunupay-sys/" ;




	//PROD
	assureServiceLink = 'https://api.hybraine.com/assurance/courtier/' ;

	//DEV
	//assureServiceLink = 'https://devdjolof.hybraine.com/assurance/courtier/' ;



  constructor(private http: HttpClient) { }


  getAllCompagniesServing(samacaabiyoonwii: string): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getAllCompagniesServing.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllCompagnies(samacaabiyoonwii: string): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getAllCompagnies.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  updateStatutClient(samacaabiyoonwii: string, idecheance: any, statut: any): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, idecheance:idecheance, statut:statut } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    this.remotelogger(this.assureServiceLink+'updateStatutClient.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  getSameKindAssuranceTypeConfigs(samacaabiyoonwii: string, typeInsurance: string): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, typeassurance:typeInsurance} ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    this.remotelogger(this.assureServiceLink+'getSmKndInsurTypConfigs.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllInsuranceTypes(samacaabiyoonwii: string): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getAllInsuranceTypes.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getAllGlobalVarFin(samacaabiyoonwii: string): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getAllGlobalVarFin.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getAllConfigsglobal(samacaabiyoonwii: string): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getConfigyeupp.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getAllPossibleParamsForThisGarantie(samacaabiyoonwii: string, intituleGarantie): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, intituleGarantie:intituleGarantie} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getAllPotenParamsGarantie.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  validerEtSouscrire(sendThisBody): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = sendThisBody ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'souscriptionmono.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }




  demFayyDieuliDji(sendThisBody): Promise<ReponseWebService>{  
    return new Promise( (resolve, reject) => {

		let postData = sendThisBody ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'prepaid/paysouscript/'+'fayydieul.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getpropbyCurrentHYOU(samacaabiyoonwii, currentHYIOU): Promise<ReponseWebService>{

		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii, currentHYIOU: currentHYIOU} ;  
		    let backData  : ReponseWebService ;

		    console.log("getpropbyCurrentHYOU:", postData) ;

		    this.remotelogger(this.assureServiceLink+'getpropbyCurrentHYOU.php', postData ).subscribe(
		        retourPost => {        
		        	console.log(backData) ;  
		          	backData = retourPost ;
		        },
		        response => {
		        	console.log(backData) ;  
	            	backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }

  getsoldedutome(sendThisBody): Promise<ReponseWebService>{  
    return new Promise( (resolve, reject) => {

		let postData = sendThisBody ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'prepaid/laacsawall/'+'getsoldedutome.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  yeessalaatCaabiWaadji(samacaabiyoonwii, iduser): Promise<ReponseWebService>{

		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii, iduser: iduser} ;  
		    let backData  : ReponseWebService ;

		    console.log("yeessal:", postData) ;

		    this.remotelogger(this.assureServiceLink+'reinitializePassword.php', postData ).subscribe(
		        retourPost => {        
		        	console.log(backData) ;  
		          	backData = retourPost ;
		        },
		        response => {
		        	console.log(backData) ;  
	            	backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }



  soppandietatwoucomptebi(samacaabiyoonwii, iduser, state): Promise<ReponseWebService>{

		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii, iduser: iduser, state: state} ;  
		    let backData  : ReponseWebService ;

		    console.log("yeessal:", postData) ;

		    this.remotelogger(this.assureServiceLink+'soppandietatwoucomptebi.php', postData ).subscribe(
		        retourPost => {        
		        	console.log(backData) ;  
		          	backData = retourPost ;
		        },
		        response => {
		        	console.log(backData) ;  
	            	backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }


  getAllProfils(samacaabiyoonwii): Promise<ReponseWebService>{

		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : ReponseWebService ;

		    console.log(postData) ;

		    this.remotelogger(this.assureServiceLink+'getallprofils.php', postData ).subscribe(
		        retourPost => {        
		        	console.log(backData) ;  
		          	backData = retourPost ;
		        },
		        response => {
		        	console.log(backData) ;  
	            	backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }


  getgarantiesbypolicerf(samacaabiyoonwii, policeref): Promise<ReponseWebService>{

		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii, policeref: policeref} ;  
		    let backData  : ReponseWebService ;

		    console.log(postData) ;

		    this.remotelogger(this.assureServiceLink+'getgarantiesbypolicerf.php', postData ).subscribe(
		        retourPost => {        
		        	console.log(backData) ;  
		          	backData = retourPost ;
		        },
		        response => {
		        	console.log(backData) ;  
	            	backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }


  getAllPoints(samacaabiyoonwii): Promise<ReponseWebService>{

		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : ReponseWebService ;

		    console.log(postData) ;

		    this.remotelogger(this.assureServiceLink+'getallpoints.php', postData ).subscribe(
		        retourPost => {        
		        	console.log(backData) ;  
		          	backData = retourPost ;
		        },
		        response => {
		        	console.log(backData) ;  
	            	backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }

  getAllPointsSubNet(samacaabiyoonwii): Promise<ReponseWebService>{

		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : ReponseWebService ;

		    console.log(postData) ;

		    this.remotelogger(this.assureServiceLink+'getallpointssubnet.php', postData ).subscribe(
		        retourPost => {        
		        	console.log(backData) ;  
		          	backData = retourPost ;
		        },
		        response => {
		        	console.log(backData) ;  
	            	backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }

  getReportingDashbordPourKii(samacaabiyoonwii, datedeb, datefin, idwaadji): Promise<ReponseWebService>{

	return new Promise( (resolve, reject) => {
		let postData = {token: samacaabiyoonwii, samacaabiyoonwii: samacaabiyoonwii, 
								dateDebut: datedeb, dateFin: datefin, idwaadji: idwaadji} ;  
		let backData  : ReponseWebService ;

		console.log(postData) ;

		this.remotelogger(this.assureServiceLink+'getHistoVentePourKii.php', postData ).subscribe(
			retourPost => {          
				  backData = retourPost ;
			},
			response => {
			backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
			},
			() => {
				resolve(backData);
			}
		   ) ;
		});
	}


  getReportingDashbord(samacaabiyoonwii, datedeb, datefin): Promise<ReponseWebService>{

	return new Promise( (resolve, reject) => {
		let postData = {token: samacaabiyoonwii, samacaabiyoonwii: samacaabiyoonwii, dateDebut: datedeb, dateFin: datefin} ;  
		let backData  : ReponseWebService ;

		console.log(postData) ;

		this.remotelogger(this.assureServiceLink+'getHistoVente.php', postData ).subscribe(
			retourPost => {          
				  backData = retourPost ;
			},
			response => {
			backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
			},
			() => {
				resolve(backData);
			}
		   ) ;
		});
	}


  getReportingPoliceVers(samacaabiyoonwii, datedeb, datefin): Promise<ReponseWebService>{

	return new Promise( (resolve, reject) => {
		let postData = {token: samacaabiyoonwii, samacaabiyoonwii: samacaabiyoonwii, dateDebut: datedeb, dateFin: datefin} ;  
		let backData  : ReponseWebService ;

		console.log(postData) ;

		this.remotelogger(this.assureServiceLink+'getHistoPoliceRever.php', postData ).subscribe(
			retourPost => {          
				  backData = retourPost ;
			},
			response => {
			backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
			},
			() => {
				resolve(backData);
			}
		   ) ;
		});
	}

  getSituationsEver(samacaabiyoonwii, datedeb, datefin): Promise<ReponseWebService>{

	return new Promise( (resolve, reject) => {
		let postData = {token: samacaabiyoonwii, samacaabiyoonwii: samacaabiyoonwii, dateDebut: datedeb, dateFin: datefin} ;  
		let backData  : ReponseWebService ;

		console.log(postData) ;

		this.remotelogger(this.assureServiceLink+'getSituationAllTimeForMe.php', postData ).subscribe(
			retourPost => {          
				  backData = retourPost ;
			},
			response => {
			backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
			},
			() => {
				resolve(backData);
			}
		   ) ;
		});
  }

  getSituationPeriodeDashbord(samacaabiyoonwii, datedeb, datefin): Promise<ReponseWebService>{

	return new Promise( (resolve, reject) => {
		let postData = {token: samacaabiyoonwii, samacaabiyoonwii: samacaabiyoonwii, dateDebut: datedeb, dateFin: datefin} ;  
		let backData  : ReponseWebService ;

		console.log(postData) ;

		this.remotelogger(this.assureServiceLink+'getSituationPeriode.php', postData ).subscribe(
			retourPost => {          
				  backData = retourPost ;
			},
			response => {
			backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
			},
			() => {
				resolve(backData);
			}
		   ) ;
		});
	}


  getBigChiffres(samacaabiyoonwii): Promise<ReponseWebService>{

	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		let backData  : ReponseWebService ;

		console.log(postData) ;

		this.remotelogger(this.assureServiceLink+'getAggrega.php', postData ).subscribe(
			retourPost => {          
				  backData = retourPost ;
			},
			response => {
			backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
			},
			() => {
				resolve(backData);
			}
		   ) ;
		});
	}



  getAllOps(samacaabiyoonwii,datedeb, datefin): Promise<any>{  
  	
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii : samacaabiyoonwii,  dateBiniouTambalei:datedeb, dateBiniouDieekhal:datefin} ;  

	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    this.remotelogger(this.assureServiceLink+'reversement/allOpsPeriodeForMoom.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  getAllOpsAppelFonds(samacaabiyoonwii,datedeb, datefin): Promise<any>{  
  	
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii : samacaabiyoonwii,  dateBiniouTambalei:datedeb, dateBiniouDieekhal:datefin} ;  

	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    this.remotelogger(this.assureServiceLink+'prepaid/laacsawall/allOpsPeriodeForMoomAppFonds.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  mettreAjourLaProposition(samacaabiyoonwii, refPropOnDB, valeurBonus, valeurReduc, accessoire): Promise<any>{  
  	
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii : samacaabiyoonwii,  
							refPropOnDB:refPropOnDB, 
								valeurBonus:valeurBonus,
									valeurReduc:valeurReduc,
									accessoire:accessoire} ;  

	    let backData  : ReponseWebService ;

	    console.log(postData) ;
	    								
	    this.remotelogger(this.assureServiceLink+'updateproposition.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllOpsToExport(samacaabiyoonwii,datedeb, datefin): Promise<any>{  
  	
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii : samacaabiyoonwii,  dateBiniouTambalei:datedeb, dateBiniouDieekhal:datefin} ;  

	    let backData  : ReponseWebService ;

	    console.log(postData) ;
	    								
	    this.remotelogger(this.assureServiceLink+'reversement/allOpsPeriodeForMoomexporter.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  initierVersementAgent(param): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = param ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'reversement/initierVersement.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  recevoirMesFonds(param): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = param ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'prepaid/laacsawall/dieulsamamoomel.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  checkPayStatusWave(samacaabiyoonwii, idwaveop): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idwaveop: idwaveop } ;
	    let backData  : ReponseWebService ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'reversement/checkstatutwavepay.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  checkPayStatusOM(samacaabiyoonwii, idomop): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idomop: idomop } ;
	    let backData  : ReponseWebService ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'reversement/checkstatutompay.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }




  checkPayStatusWavePrepaid(samacaabiyoonwii, idwaveop): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idwaveop: idwaveop } ;
	    let backData  : ReponseWebService ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'prepaid/paysouscript/checkstatutwavepay.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  checkPayStatusOMPrepaid(samacaabiyoonwii, idomop): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idomop: idomop } ;
	    let backData  : ReponseWebService ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'prepaid/paysouscript/checkstatutompay.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }




  getAllTransactsByDateIntervaladm(samacaabiyoonwii, datedeb, datefin): Promise<ReponseWebService>{

		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii, dateBiniouTambalei: datedeb, dateBiniouDieekhal: datefin} ;  
		    let backData  : ReponseWebService ;

		    this.remotelogger(this.assureServiceLink+'gethistoadm.php', postData ).subscribe(
		        retourPost => {          
		          	backData = retourPost ;
		        },
		        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }



  getAllPossibleGarantiesCompagnie(samacaabiyoonwii: string, idtypeassure, uneCompagnie, idcategorie): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, typeraniee:idtypeassure, uneCompagnie:uneCompagnie, idcategorie:idcategorie} ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    this.remotelogger(this.assureServiceLink+'getAllPossibleGarantiesCompagnie.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllPossibleGarantiesGLobalFunc(samacaabiyoonwii: string, idtypeassure, idcategorie): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, typeraniee:idtypeassure, idcategorie:idcategorie} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getAllPossibleGarantiesMacro.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllPossibleGaranties(samacaabiyoonwii: string, idtypeassure, idcategorie): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, typeraniee:idtypeassure, idcategorie:idcategorie} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getAllPossibleGaranties.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getAllBigCategories(samacaabiyoonwii: string, idtypeassure): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, typeraniee:idtypeassure} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getAllBigCategories.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  duplicateThisConfig(samacaabiyoonwii, configToDuplicate): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii: samacaabiyoonwii, duplicataBi:configToDuplicate } ;

	    let backData  : ReponseWebService ;

	    console.log("DuplicCONFIGSERVICE ",postData) ;

	    this.remotelogger(this.assureServiceLink+'duplicatethisconfig.php', postData ).subscribe(
	        retourPost => {          
	        	
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  } 


  addNewConfig(idUser, config, nomassurance, infosup, myAddedParts): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, config:config, nomassurance:nomassurance,  infosup:infosup, myAddedParts:myAddedParts } ;

	    let backData  : ReponseWebService ;

	    console.log("ADDCONFIGSERVICE : ", postData) ;

	    this.remotelogger(this.assureServiceLink+'addconfig.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  cancelTransaction(samacaabiyoonwii, refPolice, nomcompagnie, refExterneTransact,
  					categorie, avenant, kideffoonTransactionBi, lissidess, immatriculation): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, refPolice:refPolice, 
  					nomcompagnie:nomcompagnie, refExterneTransact:refExterneTransact, 
  					categorie:categorie, avenant:avenant, 
  					kideffoonTransactionBi:kideffoonTransactionBi, lissidess:lissidess, immatriculation:immatriculation} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'cancelTransaction.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  checkavenant(samacaabiyoonwii, choosencompagnieName, 
  					nomcategorie, nomavenant, propRetenue): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, choosencompagnieName:choosencompagnieName, 
  					nomcategorie:nomcategorie, nomavenant:nomavenant, propRetenue:propRetenue} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'checkavenant.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAvenantsYiAmYeupp(samacaabiyoonwii): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getallavenants.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllAvenantsCompos(samacaabiyoonwii): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getallforavenantconfig.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllCanals(samacaabiyoonwii): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getallcanals.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllPacks(idcompagnie, idtype, idbigcategorie, idcanal): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {idcompagnie: idcompagnie, typeraniee: idtype, idbigcategorie:idbigcategorie, idcanal:idcanal} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getallpacks.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllPacksVisibleCompagnie(idcompagnie, idtype, idbigcategorie, uneCompagnie): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {idcompagnie: idcompagnie, typeraniee: idtype, idbigcategorie:idbigcategorie, uneCompagnie:uneCompagnie} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getallpacksvisiblecompagnie.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }




  getAllPacksVisible(idcompagnie, idtype, idbigcategorie): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {idcompagnie: idcompagnie, typeraniee: idtype, idbigcategorie:idbigcategorie} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getallpacksvisible.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllAvenantForThisCompagnieAndInsuranceTypeCateg(idcompagnie, idtype, idChoosenBigCateg): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {idcompagnie: idcompagnie, typeraniee: idtype, idCategorie:idChoosenBigCateg} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getAvenantConfigForThese.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllFrais(idcompagnie, idtype, idChoosenBigCateg): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {idcompagnie: idcompagnie, typeraniee: idtype, idCategorie:idChoosenBigCateg} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getAllFrais.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  getAllConfigs(idcompagnie, idtype, idbigcateg): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {
		let postData = {idcompagnie: idcompagnie, typeraniee: idtype, idcategorie: idbigcateg} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getConfigs.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  updatePackPublic(idUser, pack): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, pack:pack } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData); 

	    this.remotelogger(this.assureServiceLink+'updatepackpublic.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  updatePack(idUser, pack): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, pack:pack } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData); 

	    this.remotelogger(this.assureServiceLink+'updatepack.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  getAllHabilitations(samacaabiyoonwii: string): Promise<any>{
	return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getallhabilitations.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        	console.log(backData) ;  
	        },
	        response => {
	        	console.log(backData) ;  
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  updateVarFin(samacaabiyoonwii, fraischarge): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii: samacaabiyoonwii, fraischarge:fraischarge } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData); 

	    this.remotelogger(this.assureServiceLink+'updatevarfin.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  updateVarAvenant(samacaabiyoonwii, fraischarge): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii: samacaabiyoonwii, fraischarge:fraischarge } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData); 

	    this.remotelogger(this.assureServiceLink+'updatevaravenant.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  updateConfig(idUser, config, nomassurance, infosup): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, config:config, nomassurance: nomassurance, infosup:infosup } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData); 

	    this.remotelogger(this.assureServiceLink+'updateconfig.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  updateNomAssurance(idUser, nomassurance, newname, newIntitule): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, nomassurance:nomassurance, newname:newname, intitule:newIntitule } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    this.remotelogger(this.assureServiceLink+'updatenomass.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  updatePolicy(idUser, nomassurance, policyValue): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, nomassurance:nomassurance, policy:policyValue } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    this.remotelogger(this.assureServiceLink+'updatePolicy.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  deleteAssurance(idUser, nomassurance): Promise<ReponseWebService>{
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, nomassurance:nomassurance } ;  
	    let backData  : ReponseWebService ;

	    console.log("Suppress ", postData) ;

	    this.remotelogger(this.assureServiceLink+'deleteconfig.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


/****************************************** START FROM FINANCIAL SYS DJOLOF********************************************************************/

	getAllCompagniesPart(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrlRemFirstSys+'getCompagniesPart.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}

	getAllActifsPoints(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrlRemFirstSys+'allActifsPoints.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getAllInactifsPoints(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrlRemFirstSys+'allInactifsPoints.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getAllActifsUsers(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrlRemFirstSys+'allActifsUsers.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getAllInactifsUsers(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrlRemFirstSys+'allInactifsUsers.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}



  getAllPartners(samacaabiyoonwii): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
	    let backData  : any ;

	    this.remotelogger(this.assureServiceLink+'getallusers.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }

  getAllPartnersSubNet(samacaabiyoonwii): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
	    let backData  : any ;

	    this.remotelogger(this.assureServiceLink+'getalluserssubnet.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


/****************************************** END FROM FINANCIAL SYS DJOLOF********************************************************************/





  addNewInsurType(samacaabiyoonwii, nomtypeinsur): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii: samacaabiyoonwii, nomtypeinsur: nomtypeinsur} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'addNewInsurType.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  addNewGarantie(samacaabiyoonwii, typeinsur, theGarantie): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii: samacaabiyoonwii, typeinsur: typeinsur, 
							nomGarantie:theGarantie.nomgarantie,
							descriptGarantie : theGarantie.descriptGarantie  } ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'addNewGarantie.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  addNewBigCateg(samacaabiyoonwii, typeinsur, theNewBigCateg): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii: samacaabiyoonwii, typeinsur: typeinsur, theNewBigCateg:theNewBigCateg } ;  
	    let backData  : ReponseWebService ;
	    console.log(postData) ;
	    this.remotelogger(this.assureServiceLink+'addNewBigCateg.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  addNewParamPredefTrueFunct(idUser, nomparam, nomFrmt, paramvalues, allInfosSupplem): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, paramvalues: JSON.stringify(paramvalues), 
				nomparam:nomparam, nomFrmt: nomFrmt, infosup: JSON.stringify(allInfosSupplem) } ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'addparampredfTrueFunct.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  addNewParamPredef(idUser, nomparam, nomFrmt, paramvalues): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, paramvalues: JSON.stringify(paramvalues), 
				nomparam:nomparam, nomFrmt: nomFrmt } ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'addparampredf.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  uppatePackDescript(idpack, packDescript): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {idpack:idpack, packDescript:packDescript} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'uppatepackdescript.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }
    


  addPack(choosencompagnieID, choosencompagnieName, 
  				choosenInsuranceTypeRaniee, choosenInsuranceTypeName, 
  					choosenBigCateg, packName, leCanalPrivilegie): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {choosencompagnieID: choosencompagnieID,
				choosencompagnieName:choosencompagnieName, choosenInsuranceTypeRaniee: choosenInsuranceTypeRaniee,
				choosenInsuranceTypeName:choosenInsuranceTypeName,
				 choosenBigCateg:choosenBigCateg, packName:packName, canal:leCanalPrivilegie} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'addpack.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  addAvenantComposante(choosencompagnieID, choosencompagnieName, 
  				choosenInsuranceTypeRaniee, choosenInsuranceTypeName, 
  					choosenBigCateg, nomAvenant, varName): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {choosencompagnieID: choosencompagnieID,
				choosencompagnieName:choosencompagnieName, choosenInsuranceTypeRaniee: choosenInsuranceTypeRaniee,
				choosenInsuranceTypeName:choosenInsuranceTypeName,
				 choosenBigCateg:choosenBigCateg, nom:nomAvenant, nomcomposantemajeure:varName} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'addavenantcompos.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  addAvenantToCompagnie(choosencompagnieID, choosencompagnieName, 
  				choosenInsuranceTypeRaniee, choosenInsuranceTypeName, 
  					choosenBigCateg, varName): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {choosencompagnieID: choosencompagnieID,
				choosencompagnieName:choosencompagnieName, choosenInsuranceTypeRaniee: choosenInsuranceTypeRaniee,
				choosenInsuranceTypeName:choosenInsuranceTypeName,
				 choosenBigCateg:choosenBigCateg, nom:varName} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'addavenant.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  addVarFin(choosencompagnieID, choosencompagnieName, 
  				choosenInsuranceTypeRaniee, choosenInsuranceTypeName, 
  					choosenBigCateg, varName): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {

		let postData = {choosencompagnieID: choosencompagnieID,
				choosencompagnieName:choosencompagnieName, choosenInsuranceTypeRaniee: choosenInsuranceTypeRaniee,
				choosenInsuranceTypeName:choosenInsuranceTypeName,
				 choosenBigCateg:choosenBigCateg, nomvariable:varName} ;  

		console.log(postData) ;

	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'addvarfin.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  addNewConstante(idUser, nomconst, descript, valeur): Promise<ReponseWebService>{   
    return new Promise( (resolve, reject) => {nomconst

		let postData = {idUser: idUser, nomconst: nomconst, 
				descript:descript, valeur: valeur } ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'addconstante.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllParamsPredef(idUser): Promise<ReponseWebService>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser} ;  
	    let backData  : ReponseWebService ;

	    this.remotelogger(this.assureServiceLink+'getPredefparams.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;
	          	console.log(backData) ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  getAllParamRecurrent(idUser, nomFrmtRec): Promise<ReponseWebService>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, nomFrmtRec: nomFrmtRec} ;  
	    let backData  : ReponseWebService ;
	    console.log("1124 " , postData) ;

	    this.remotelogger(this.assureServiceLink+'getRecurrentparams.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;
	          	console.log(backData) ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getInfosCar(idUser, immatriculation): Promise<ReponseWebService>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, mtrcl:immatriculation} ;  

	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    //this.remotelogger(this.assureServiceLink+'getDevis.php', postData ).subscribe(
	    this.remotelogger('https://api.hybraine.com/assurance/getInfosCar.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	   	
	});
  }

  getDevis(idUser, nomassurance, nomcateg, allgarantie, matricule, duree, params, paramvalues, idcompagnie, idtypeassurance, idbigcategorie): Promise<ReponseWebService>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, nomAssurance:nomassurance, nomCateg:nomcateg, allgarantie:allgarantie,
							 matricule:matricule, duree:duree, params:params, paramsValues:paramvalues,
							 idcompagnie:idcompagnie, idtypeassurance:idtypeassurance, idbigcategorie:idbigcategorie} ;  

	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    //this.remotelogger(this.assureServiceLink+'getDevis.php', postData ).subscribe(
	    this.remotelogger(this.assureServiceLink+'getDevisGlobaleVersion.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;
	          	console.log(backData) ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	   	
	});
  }


   getDevisComparateur(idUser, nomassurance, nomcateg, allgarantie, infoscar, duree, params, paramvalues, compagnies, idtypeassurance, idbigcategorie): Promise<ReponseWebService>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, nomAssurance:nomassurance, nomCateg:nomcateg, allgarantie:allgarantie,
							 infoscar:infoscar, duree:duree, params:params, paramsValues:paramvalues,
							 compagnies:compagnies, idtypeassurance:idtypeassurance, idbigcategorie:idbigcategorie, ranieel:Date.now() } ;  

	    let backData  : ReponseWebService ;

	    console.log(postData) ;

	    //this.remotelogger(this.assureServiceLink+'getDevis.php', postData ).subscribe(
	    this.remotelogger(this.assureServiceLink+'getDevisComparateur.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;
	          	console.log(backData) ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	   	
	});
  }




  souscrire(idUser, nomAssurance, nomCateg, alldevis, matricule, duree, infoscar, paramsValues, total, nomclient, prenomclient, telephoneclient): Promise<ReponseWebService>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, nomAssurance:nomAssurance, nomCateg:nomCateg, alldevis:alldevis, matricule:matricule, duree:duree, infoscar:JSON.stringify(infoscar), paramsValues:paramsValues, total: total, nomclient:nomclient, prenomclient:prenomclient, telephoneclient:telephoneclient} ;  
	    let backData  : ReponseWebService ;

	    console.log(JSON.stringify(postData)) ;

	    this.remotelogger(this.assureServiceLink+'souscrire.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;
	          	console.log(backData) ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	   	
	});
  }

  getSamayClients(samacaabiyoonwii, datedeb, datefin): Promise<ReponseWebService>{

		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii, datedeb: datedeb, datefin: datefin} ;  
		    let backData  : ReponseWebService ;

		    this.remotelogger(this.assureServiceLink+'getSamayClients.php', postData ).subscribe(
		        retourPost => {          
		          	backData = retourPost ;
		        },
		        response => {
		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }


  getGlobalProductionByDateInterval(idUser, datedeb, datefin): Promise<ReponseWebService>{

		return new Promise( (resolve, reject) => {
			let postData = {idUser: idUser, datedeb: datedeb, datefin: datefin} ;  
		    let backData  : ReponseWebService ;

		    this.remotelogger(this.assureServiceLink+'getproductionbydateintervalle.php', postData ).subscribe(
		        retourPost => {          
		          	backData = retourPost ;
		        },
		        response => {
		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }


  getDetailProdLine(idprod): Promise<ReponseWebService>{
		return new Promise( (resolve, reject) => {
			let postData = {idprod: idprod} ;  
		    let backData  : ReponseWebService ;

		    this.remotelogger(this.assureServiceLink+'getDetailProdLine.php', postData ).subscribe(
		        retourPost => {          
		          	backData = retourPost ;
		        },
		        response => {
		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }



  createPointAgency(samacaabiyoonwii, companyName, regionPoint, adressepoint): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, 
							companyName:companyName, 
							regionPoint:regionPoint, 
								adressepoint:adressepoint} ;  
	    let backData  : ReponseWebService ;
	    
	    this.remotelogger(this.assureServiceLink+'addPoint.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  creerProfil(samacaabiyoonwii, nomprofil, otherInfos): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, nomprofil:nomprofil, otherInfos:otherInfos} ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'creerprofil.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  updateProfil(samacaabiyoonwii, nomprofil, otherInfos, idprofil): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, nomprofil:nomprofil, otherInfos:otherInfos, idprofil:idprofil } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'updateprofil.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  yokkMeunMeunoukii(samacaabiyoonwii, fimouNekk): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, fimouNekk: fimouNekk } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'yokkMeunMeunoukii.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  updateUserdetails(samacaabiyoonwii, canal, compliances, iduser): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, canal:canal, compliances:compliances, iduser: iduser } ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'updateUserdetails.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  createCompanyAndAdmin(idUser, companyName, sigle, prenomUser, nomUser, telephoneUser, loginUser): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, companyName:companyName, sigle:sigle, prenomUser:prenomUser, nomUser:nomUser, telephoneUser:telephoneUser, loginUser:loginUser} ;  
	    let backData  : ReponseWebService ;
	    
	    this.remotelogger(this.assureServiceLink+'addCompanyAndAdmin.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  createCourtier(idUser, companyName, sigle, prenomUser, nomUser, telephoneUser, loginUser): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, companyName:companyName, sigle:sigle, prenomUser:prenomUser, nomUser:nomUser, telephoneUser:telephoneUser, loginUser:loginUser} ;  
	    let backData  : ReponseWebService ;
	    
	    this.remotelogger(this.assureServiceLink+'addCourtier.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  createUserComparateur(body): Promise<ReponseWebService>{

    return new Promise( (resolve, reject) => {
		let postData = body ;  
	    let backData  : ReponseWebService ;

	    console.log(postData) ;
	    
	    this.remotelogger(this.assureServiceLink+'addUser.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : ''};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  remotelogger(url: string, sentData: any) {
    return this.http.post<ReponseWebService>(url, sentData, httpOptions);
  }


}
